import { requestGet } from '../request'
import apiPath from './apiPath'

const api = {
  // Returns every active message group across all vendors. f_status is left
  // unset so the backend's active-only default applies; callers filter by
  // vendor client-side.
  GetAllMessageGroup() {
    return requestGet(apiPath.MESSAGE_GROUP_LIST.path)
  }
}

export default api
